import { useEffect } from "react";
import Login from "../Login/Login";

const Logout = ({ setLogin }: { setLogin: any }) => {
  useEffect(() => {
    // Update the authentication state to 'false' in localStorage
    localStorage.setItem("isAuthenticated", "false");
    setLogin(false);
  }, [setLogin]);

  return (
    <div className="main-body-section login-screen-wrap d-flex">
      <Login setLogin={setLogin} />
    </div>
  );
};

export default Logout;
